/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import * as models from '../model/models';
import { Requester } from '../requester';
import { PagedArray } from '../paged-array';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class ImagesApi {
    constructor(
        protected requester: Requester
    ) {
    }

    /**
     * Get image URL
     * @param domain 
     * @param image_path 
     */
    public getImage(domain?: string, image_path?: string, __unused?: any): Observable<{}> {
        const path = '/images/{domain}/{image_path}'
                    .replace('{' + 'domain' + '}', String(domain))
                    .replace('{' + 'image_path' + '}', String(image_path));

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<any>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

}
